import { TokenListItem } from './components';

interface CoinsInfoProps {
	tonBalance: string;
	shuriBalance: string;
	usdtBalance: string;
}

export const TokenList: React.FC<CoinsInfoProps> = ({
	tonBalance,
	shuriBalance,
	usdtBalance,
}: CoinsInfoProps) => {
	/*********************
	// #region Template
	**********************/
	return (
		<div className="flex flex-col items-center justify-center mt-5 gap-3">
			<TokenListItem
				tokenBalance={tonBalance}
				symbol="TON"
				image={process.env.VITE_TON_COIN_IMAGE!}
			/>
			<TokenListItem
				tokenBalance={usdtBalance}
				symbol="USDT"
				image={process.env.VITE_USDT_COIN_IMAGE!}
			/>
			<TokenListItem
				tokenBalance={shuriBalance}
				symbol="SHURI"
				image={process.env.VITE_SHURI_COIN_IMAGE!}
			/>
		</div>
	);
};
